var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<form name=\"vm.detailForm\"><div flex=\"flex\" layout=\"row\"><div flex=\"100\" align-content=\"flex-start\" layout=\"column\"><div layout=\"row\"><div flex=\"25\" class=\"form-group\"><label for=\"name\" class=\"control-label\">Group Name</label><input ng-model=\"vm.docSvc.doc.name\" class=\"form-control\"/></div><div flex=\"60\" class=\"form-group\"><label for=\"description\" class=\"control-label\">Description</label><input ng-model=\"vm.docSvc.doc.description\" class=\"form-control\"/></div></div></div></div></form>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/units/tabs/top-panel.jade
// module id = 225
// module chunks = 0